<template>
  <aside class="hidden lg:block w-[100px] h-screen bg-dark-foreground rounded-3xl print:hidden">
    <ul class="pt-10">
      <li class="w-full h-20 px-4 py-2">
        <img src="../../assets/img/logo.png" alt="" class="w-16 logo-shadow">
      </li>
      
      <SideMenuItem to="/" v-if="user.role.type === 'reception' || user.role.type === 'admin' || user.role.type === 'housekeeping'">
        <HomeIcon class="mx-auto"/>
      </SideMenuItem>

      <SideMenuItem to="/orders/shop" v-if="user.role.type === 'shop' || user.role.type === 'admin'">
        <ShopIcon class="mx-auto"/>
      </SideMenuItem>

      <SideMenuItem to="/orders/restaurant" v-if="user.role.type === 'restaurant' || user.role.type === 'admin'">
        <PizzaIcon class="mx-auto w-[24px] h-[24px]"/>
      </SideMenuItem>

      <SideMenuItem to="/orders/caffe" v-if="user.role.type === 'caffe' || user.role.type === 'admin'">
        <CoffeeIcon class="mx-auto w-[24px] h-[24px]"/>
      </SideMenuItem>

      <SideMenuItem to="/setting">
        <GearIcon class="mx-auto"/>
      </SideMenuItem>
    </ul>
  </aside>
</template>

<script>
import HomeIcon from "@/components/Icons/HomeIcon";
import SideMenuItem from "@/components/Homepage/SideMenuItem";
import GearIcon from "@/components/Icons/GearIcon";
import {mapState} from "vuex";
import ShopIcon from "@/components/Icons/ShopIcon";
import PizzaIcon from "@/components/Icons/PizzaIcon";
import CoffeeIcon from "@/components/Icons/CoffeeIcon";

export default {
  name: "SideMenu",
  components: {
    CoffeeIcon,
    PizzaIcon,
    ShopIcon,
    GearIcon,
    SideMenuItem,
    HomeIcon
  },
  computed: {
    ...mapState(['user'])
  }
}
</script>

<style scoped>

</style>